module.exports = __webpack_public_path__ + "img/tayo-video-thumbnail.3c60fd9e.png";